import { TEXTOS } from '../../lib/glossario'
import type { ArquivoTocado } from '../../types/repositorios'

const INTEIRO = new Intl.NumberFormat('pt-BR')

/**
 * Os arquivos mais tocados no período.
 *
 * Caminho em fonte mono com quebra livre: caminho de arquivo do e-Cidade passa fácil de 80
 * caracteres, e truncar esconderia justamente o nome do arquivo, que fica no fim.
 *
 * @param props os arquivos, do mais tocado para o menos
 * @returns a lista, ou nada quando não há arquivo medido
 */
export function ArquivosMaisTocados({ arquivos }: { arquivos: ArquivoTocado[] }) {
  const t = TEXTOS.repositorios.modificado
  if (arquivos.length === 0) {
    return null
  }
  return (
    <div>
      <h3 className="px-3 text-sm font-semibold text-slate-800">{t.arquivos}</h3>
      <table className="mt-2 min-w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-xs font-semibold text-slate-500">
            <th className="px-3 py-2">{t.colunas.caminho}</th>
            <th className="px-3 py-2 text-right">{t.colunas.commits}</th>
            <th className="px-3 py-2 text-right">{t.colunas.pessoas}</th>
          </tr>
        </thead>
        <tbody>
          {arquivos.map((arquivo) => (
            <tr key={arquivo.caminho} className="border-b border-slate-100 last:border-0">
              <td className="break-all px-3 py-1.5 font-mono text-xs text-slate-900">{arquivo.caminho}</td>
              <td className="whitespace-nowrap px-3 py-1.5 text-right font-semibold tabular-nums text-slate-900">
                {INTEIRO.format(arquivo.commits)}
              </td>
              <td className="whitespace-nowrap px-3 py-1.5 text-right tabular-nums text-slate-700">{INTEIRO.format(arquivo.pessoas)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
